import {FieldErrors, FieldErrorsImpl} from "react-hook-form/dist/types/errors";
import * as React from "react";
import { Merge } from "react-hook-form";

export const InputError = (props: { name: string, errors: FieldErrors<any>, invalidText?: string }) => {
    let name = props.name;
    let errors = props.errors;
    let error: any;
    if (name.startsWith("attributes.") && errors.attributes) {
        let attributeName = name.replaceAll("attributes.", "");
        const errorsAttributes = errors.attributes as keyof FieldErrors | Merge<FieldErrors, FieldErrorsImpl<any>>
        error = errorsAttributes[attributeName as any];
    } else {
        error = errors[name];
    }
    if (error.message) {
        return <span className="help-block input-error">{error.message}</span>
    } else {
        return <span className="help-block input-error">{props.invalidText}</span>
    }
}